export enum VehicleCondition {
    NEW = 'NEW',
    USED = 'USED'
}
